import { useReactiveFeatureFlag } from '@/utils/useFeatureFlags'

export const newSidebarEnabled = () => {
  const { enabled } = useReactiveFeatureFlag('hermes.newSidebar')
  return { isEnabled: enabled }
}
